import type { HomeWidgetDescriptor } from "../../api/hub/home";
import { HomePanel } from "./Frame";
export function HomeLibrary(
  { descriptors, count, onAdd, onClose }: {
    descriptors: HomeWidgetDescriptor[];
    count: number;
    onAdd: (descriptor: HomeWidgetDescriptor) => void;
    onClose: () => void;
  },
) {
  const native = descriptors.filter((item) => item.type.startsWith("native:")),
    apps = descriptors.filter((item) => item.type.startsWith("app:"));
  return (
    <HomePanel title="部件库" onClose={onClose}>
      <p className="home-muted">
        当前角色允许的部件。每个部件独立加载，最多 24 个，已放 {count} 个。
      </p>
      {[["中台原生", native], ["可用应用作品", apps]].map((
        [heading, entries],
      ) => (
        <section key={heading as string} className="home-library-group">
          <h3>{heading as string}</h3>
          {(entries as HomeWidgetDescriptor[]).map((item) => (
            <article className="home-library-item" key={item.type}>
              <div>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                <p className="home-muted">
                  宽 {item.minW}–{item.maxW} 列 ·{" "}
                  {item.tools?.length
                    ? item.tools.join("、")
                    : "不读取业务数据"}
                </p>
              </div>
              <button
                disabled={count >= 24}
                onClick={() => onAdd(item)}
                aria-label={"添加" + item.name}
              >
                添加
              </button>
            </article>
          ))}
          {!(entries as HomeWidgetDescriptor[]).length && (
            <p className="home-empty">
              当前没有可用的应用作品。到作品库发布自己的工具，或添加全员可用作品。
            </p>
          )}
        </section>
      ))}
    </HomePanel>
  );
}
